
//mobile menu slider
document.addEventListener('DOMContentLoaded', function () {

  // PDP bundle toggle: keep the bundled product in the cart while the toggle is on
  subscribe(PUB_SUB_EVENTS.cartUpdate, async function (e) {
    if (!e.cartData || e.source === 'free-gift') return;
    const bundleItem = document.getElementById('pdp_new_bundle');
    if (!bundleItem) return;
    const bundleVariantId = Number(bundleItem.getAttribute('data-rendered-product-id'));
    if (!bundleVariantId) return;

    const cartData = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
    const bundleLine = cartData.items.find((item) => item.variant_id === bundleVariantId);
    const wantsBundle = bundleItem.classList.contains('checked');

    let request;
    if (wantsBundle && !bundleLine && cartData.item_count > 0) {
      request = fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({ items: [{ id: bundleVariantId, quantity: 1 }] })
      });
      bundleItem.dataset.addedByToggle = 'true';
    } else if (!wantsBundle && bundleLine && bundleItem.dataset.addedByToggle === 'true') {
      // Only take back what the toggle added; the bundle's own Add to cart button stays untouched
      request = fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({ id: bundleLine.key, quantity: 0 })
      });
      delete bundleItem.dataset.addedByToggle;
    }
    if (!request) return;
    await request;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
  });

    var swiper = new Swiper(".ctm_mobile_menu_slider", {
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        575: {
          slidesPerView: 2,
        },
        414: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 2,
        },
      },
    });

  //Tab js
  // home page product redirect to perticuler collection
  const { hash } = window.location;
  const cleanHashtag = hash.slice(1);

  if (hash) {
    $("ul.tabs li").each(function (index, element) {
      const Tabs = $(element).attr("tab");
      const tab_id = $(element).attr("data-tab");

      if (Tabs == cleanHashtag) {
        $(this).addClass("current");
        $("#" + tab_id).addClass("current");
        setTimeout(() => {
          $(this).trigger("click");
        }, "2000");
      } else {
        $(this).removeClass("current");
        $("#" + tab_id).removeClass("current");
      }
    });
  }

  $(".collection_grid_tab_list ul.tabs li").click(function () {
    // Ignore anchor tabs - they handle their own navigation
    if ($(this).attr("data-anchor-tab") === "true" || $(this).hasClass("anchor-tab-link")) {
      return;
    }

    const { hash } = window.location;
    if (hash) {
      history.pushState(null, null, `/collections/all`);
    }
    var tab_id = $(this).attr("data-tab");

    history.pushState(null, null, `/collections/${$(this).attr("handle")}`);

    const fetchAndReplaceContent = (
      url = window.location.href,
      elementId = "ProductGridContainer"
    ) => {
      const element = document.getElementById(elementId);

      if (element) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onload = function () {
          if (xhr.status === 200) {
            const parser = new DOMParser();
            const responseDoc = parser.parseFromString(
              xhr.responseText,
              "text/html"
            );

            const newContent = responseDoc.querySelector(`#${elementId}`);
            if (newContent) {
              element.innerHTML = newContent.innerHTML;
            }
          }
        };
        xhr.send();
      }
    };
    fetchAndReplaceContent();
  });
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  //footer menu js
  $(".footer-block__headings").click(function () {
    var targetFooterBlock = $(this).closest(".footer-block");
    var targetDetailsContent = targetFooterBlock.find(
      "ul.footer-block__details-content"
    );

    $(".footer-block").not(targetFooterBlock).removeClass("show");
    $("ul.footer-block__details-content")
      .not(targetDetailsContent)
      .removeClass("show");

    targetFooterBlock.toggleClass("show");
    targetDetailsContent.toggleClass("show");
  });

  // PDP Accordion

  $(".ctm_mobile_ans").hide();
  // $("#pdp-accordion > li:first-child").addClass("ctm_active").find(".ctm_mobile_ans").slideDown();
  $(".accordion-list > li, .accordon_item_v2_pdp").click(function (event) {
    var isPDPAcordian = $(this).parent().parent().attr('class');
    if (isPDPAcordian == 'ctm_pdp_accordion ') {
      if (!$(event.target).hasClass('accordion_inner')) {
        return;
      }
      if ($(this).hasClass("ctm_active")) {
        $(this).removeClass("ctm_active").find(".ctm_mobile_ans").slideUp();
      } else {
        $(".accordion-list > li.ctm_active .ctm_mobile_ans").slideUp();
        $(".accordion-list > li.ctm_active").removeClass("ctm_active");
        $(this).addClass("ctm_active").find(".ctm_mobile_ans").slideDown();
        // if (window.innerWidth > 768) {

        //   $('html, body').animate({
        //     scrollTop: 650
        //   }, 'smooth');
        // } else {

        //   $('html, body').animate({
        //     scrollTop: 1300
        //   }, 'smooth');
        // }
      }
    }
    return false;
  });

  // Other PDP Accordion

  $(".accordion-item-content").hide();
  $(".accordion-item > li .accordion_inner").click(function (event) {
    var accordionItem = $(this).closest(".accordion-item > li");
    if (accordionItem.hasClass("ctm_active")) {
      accordionItem.removeClass("ctm_active").find(".accordion-item-content").slideUp();
    } else {
      $(".accordion-item > li.ctm_active .accordion-item-content").slideUp();
      $(".accordion-item > li.ctm_active").removeClass("ctm_active");
      accordionItem.addClass("ctm_active").find(".accordion-item-content").slideDown();
    }
    return false;
  });

  var swiper = new Swiper(".review_slider", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".pdp-next",
      prevEl: ".pdp-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      575: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1199: {
        slidesPerView: 3,
      },
    },
  });

  var swiper = new Swiper(".timeless_slider", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".pdp-next",
      prevEl: ".pdp-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      575: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
  });

  // fancy box video POPup
  $(".fancybox").fancybox({
    buttons: ["close"],
    hash: false,
    fullScreen: true,
    touch: true,
    infobar: false,
    autoPlay: true,
    animationEffect: true,
    arrows: false,
    iframe: {
      preload: false,
    },
    video: {
      controls: 0,
      showinfo: 0,
    },
  });

  // fancy box video Auto Play for Iphone
  //$(".fancybox-video").find('video').play
  $(".fancybox-video").find("video").attr("autoplay", "autoplay");
  var vid = document.getElementsByClassName("fancybox-video");
  function playVid() {
    vid.play();
  }
  var vids = $("video");
  $.each(vids, function () {
    this.controls = false;
  });

  // img-text-mobile slider

    var swiper = new Swiper('.img-text-mobile-slider', {
      slidesPerView: '1',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
      //  sticky  Swatch change
  const colorSpans = document.querySelectorAll('span[data-value-handle]');
    colorSpans.forEach(span => {
      span.addEventListener('click', () => {
        const handle = span.getAttribute('data-value-handle');
        const input = document.querySelector(`input[type="radio"][data-value-handle="${handle}"]`);
        if (input) {
          input.click();
        } else {
        }
        colorSpans.forEach(span => {
          span.classList.remove('active_sticky_shade');
        });

        // Add 'active' class to the clicked span
        span.classList.add('active_sticky_shade');
      });

    });
    if (colorSpans.length) {
      new Swiper('.ctm-swiper-container', {
      loop: false,
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          640: {
              slidesPerView: 1,
              spaceBetween: 25,
          },
          768: {
            slidesPerView: 1.2,
            spaceBetween: 25,
          },
          1024: {
              slidesPerView: 1.5,
              spaceBetween: 25,
          },
          1440: {
              slidesPerView: 2.3,
              spaceBetween: 25,
          },
      }
  });
    }

    // checkbox div start

      async function delay(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
      }

      // Select the target span element
      async function observeDiscountChanges() {
          await delay(1000); // Introduce a 10-second delay

          var targetSpan = document.querySelector('.rtx-subscription .savings');
          if (targetSpan) {

              // Function to update the anchor tag content
              async function updateAnchor() {
                  var discountContent = targetSpan.textContent;
                  var anchorTag = document.querySelector('.disc_ausb');
                  if (anchorTag) {
                      anchorTag.textContent = discountContent;
                  }
              }

              // Create an observer instance linked to the callback function
              var observer = new MutationObserver(async function(mutations) {
                  for (const mutation of mutations) {
                      if (mutation.type === 'childList') {
                          await updateAnchor();
                      }
                  }
              });

              // Start observing the target node for configured mutations
              observer.observe(targetSpan, { childList: true, subtree: true });

              // Call updateAnchor initially in case the content is already loaded
              await updateAnchor();

          }
      }

      // Call the async function
      observeDiscountChanges();

    // checkbox div End

// modal
// Get the modal
var modelswatch = document.getElementById("myModal");

// Get the <span> element that closes the modal
var spanswatch = document.getElementsByClassName("close-btn-sticky-atc")[0];
var cartDrawer = document.getElementById("cart-icon-bubble");

if (modelswatch) {
  modelswatch.style.display = "none";
}

if (spanswatch) {
  // When the user clicks on <span> (x), close the modelswatch
  spanswatch.onclick = function () {
    modelswatch.style.display = "none";
    document.querySelectorAll(".main-sticky-atc").forEach(function (element) {
      element.style.display = "block";
    });
  }
}
if (cartDrawer && modelswatch) {
  // Opening the cart closes the variant modal
  cartDrawer.onclick = function () {
    modelswatch.style.display = "none";
    document.querySelectorAll(".main-sticky-atc").forEach(function (element) {
      element.style.display = "block";
    });
  }
}
// When the user clicks anywhere outside of the modelswatch, close it
if (modelswatch) {
  window.addEventListener('click', function (event) {
    if (event.target == modelswatch) {
      modelswatch.style.display = "none";
    }
  });
}

// Drawer upsell "Add to Cart": one request that returns the re-rendered drawer and cart bubble
function addItemToCart(variantId, button) {
  if (!variantId || (button && button.disabled)) return;
  if (button) button.disabled = true;
  const cartDrawerElement = document.querySelector('cart-drawer');
  const card = button && button.closest('.related-inner-block');
  if (cartDrawerElement && typeof cartDrawerElement.showPending === 'function' && card) {
    const image = card.querySelector('img');
    cartDrawerElement.showPending({
      title: card.querySelector('.upsell-title, h4')?.textContent.trim(),
      image: image && (image.currentSrc || image.src),
      priceLabel: card.querySelector('.upsell-price, .related-price')?.textContent.trim(),
      variantId: Number(variantId)
    });
  }
  const sections = cartDrawerElement ? cartDrawerElement.getSectionsToRender().map((section) => section.id) : [];

  fetch(routes.cart_add_url, {
    ...fetchConfig('javascript'),
    body: JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections,
      sections_url: window.location.pathname
    })
  })
    .then((response) => response.json())
    .then((state) => {
      if (state.status) {
        if (cartDrawerElement && cartDrawerElement.showPendingError) {
          cartDrawerElement.showPendingError(state.description || state.message);
        }
        return;
      }
      if (cartDrawerElement && state.sections) cartDrawerElement.renderContents(state);
    })
    .catch((error) => {
      console.error(error);
      if (cartDrawerElement && cartDrawerElement.showPendingError) cartDrawerElement.showPendingError();
    })
    .finally(() => {
      if (button) button.disabled = false;
    });
}

$(document).on('click', '.related-atc-btn', function () {
  addItemToCart($(this).data('product-id'), this);
});

});

function scrollToMainProduct() {
  document.querySelector("#main_product").scrollIntoView({
    behavior: "smooth",
  });
}

// Trusted by the best section Number counter animation
let counted = false;
$(window).scroll(function () {
  const counterElem = $("#counter_number");
  if (
    !counterElem.length ||
    counted ||
    $(window).scrollTop() <= counterElem.offset().top - window.innerHeight
  )
    return;
  counted = true;
  $(".counter-value").each(function () {
    const element = $(this);
    const countTo = element.attr("data-count");
    $({ countNum: element.text() }).animate(
      { countNum: countTo },
      {
        duration: 1000,
        easing: "swing",
        step: function () {
          element.text(Math.floor(this.countNum));
        },
        complete: function () {
          element.text(this.countNum);
        },
      }
    );
  });
});

function initializeProductSwatch(productID) {
  if (!productID) return;
  const card = document.getElementById(productID);
  if (!card) return;
  var swatchItems = card.querySelectorAll('.col-swatch li');
  swatchItems.forEach(function (swatchItem) {
    // Cards are re-scanned whenever the grid changes; bind each swatch once
    if (swatchItem.dataset.swatchBound) return;
    swatchItem.dataset.swatchBound = 'true';
    swatchItem.addEventListener("click", function () {
      var span = swatchItem.querySelector("span");
      var shponowBtn = card.querySelector(".shponow-btn");

      if (shponowBtn) {
        var atcSpan = shponowBtn.querySelector("span.col-atc");
        var soldOutSpan = shponowBtn.querySelector("span.sold-out-message");
        if (span.classList.contains("variant_disabled")) {
          shponowBtn.classList.add("btn_disable");
          atcSpan.classList.add("hidden");
          soldOutSpan.classList.remove("hidden");
        } else {
          shponowBtn.classList.remove("btn_disable");
          atcSpan.classList.remove("hidden");
          soldOutSpan.classList.add("hidden");
        }
      }

      swatchItems.forEach(function (item) {
        item.classList.remove("selected_shade");
      });

      swatchItem.classList.add("selected_shade");
      var newImage = swatchItem.getAttribute("data-href");
      var swatchTitle = swatchItem.getAttribute("data-option-title");
      // Only this card's variant select: other cards keep their own selection
      var select = card.querySelector('select[name^="id"]');
      if (select) {
        var match = Array.from(select.options).find(function (option) {
          return option.getAttribute("data-option-size") === swatchTitle;
        });
        if (match) select.value = match.value;
      }

      if (
        newImage !==
        "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif"
      ) {
        var prodImage = card.querySelector(".prod-image img");
        if (prodImage) {
          prodImage.setAttribute("src", newImage);
          prodImage.setAttribute("srcset", newImage);
        }
      }

      return false;
    });
  });
}
